/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { apiAddress } from '@/api';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import SmyMapAddress from '@/components/CustomFormList/SmyMapAddress';
export default {
  components: {
    ViewBox: ViewBox,
    XButton: XButton,
    Group: Group,
    XInput: XInput,
    SmyMapAddress: SmyMapAddress
  },
  data: function data() {
    return {
      longitude: '',
      latitude: '',
      address: '',
      map_name: '',
      defaultCode: [],
      address_type: '',
      prov_id: '',
      city_id: '',
      district_id: '',
      detail_addr: '',
      street_id: ''
    };
  },
  methods: {
    // 选择地址
    selectAddress: function selectAddress(data) {
      this.address_type = data.type;
      if (data.type === 1) {
        // 地图选址
        this.longitude = data.longitude;
        this.latitude = data.latitude;
        this.map_name = data.address;
      } else if (data.type === 2) {
        // 级联选择
        this.prov_id = data.code[0];
        this.city_id = data.code[1];
        this.district_id = data.code[2];
        this.street_id = data.code[3];
      }
    },
    addAddress: function addAddress() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.address_type) {
                  _context.next = 5;
                  break;
                }
                _this.$vux.toast.text(i18n.tc("298"));
                return _context.abrupt("return");
              case 5:
                if (!(_this.address_type === 1 && (!_this.longitude || !_this.latitude))) {
                  _context.next = 10;
                  break;
                }
                _this.$vux.toast.text(i18n.tc("298"));
                return _context.abrupt("return");
              case 10:
                if (!(_this.address_type === 2 && (!_this.prov_id || !_this.city_id || !_this.district_id))) {
                  _context.next = 13;
                  break;
                }
                _this.$vux.toast.text(i18n.tc("298"));
                return _context.abrupt("return");
              case 13:
                _context.next = 15;
                return apiAddress({
                  address_type: _this.address_type,
                  prov_id: _this.prov_id,
                  city_id: _this.city_id,
                  district_id: _this.district_id,
                  street_id: _this.street_id,
                  longitude: _this.longitude,
                  latitude: _this.latitude,
                  map_name: _this.map_name,
                  gps_addr: _this.map_name,
                  detail_addr: _this.detail_addr
                }, 'post');
              case 15:
                res = _context.sent;
                if (res.success) {
                  _this.$emit('on-success');
                  _this.$vux.toast.text(i18n.tc("307"));
                  // this.$router.go(-1)
                } else {
                  _this.$vux.toast.text(res.message);
                }
              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'determineOrder') {
      sessionStorage.setItem('name', 'shop');
    }
    next();
  }
};